import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OcpTableData } from 'shared';
import { HlmTd } from '@spartan-ng/helm/table';

import { CheckboxComponent } from '../../../../atoms';
import {
  getResolvedColumnWidth,
  TableColumnConfig,
} from '../../../table-header/table-header.interface';

@Component({
  selector: 'ocp-table-row-checkbox',
  imports: [TranslatePipe, CheckboxComponent, HlmTd],
  template: `
    <td
      hlmTableCell
      class="table-row-checkbox"
      [class]="column().cssClass"
      [style.width]="columnWidth()"
      [style.min-width]="column().minWidth"
      (click)="$event.stopPropagation()"
    >
      <ocp-checkbox
        [checked]="isSelected()"
        [disabled]="disabled()"
        (changeEvent)="onSelectChange()"
        [label]="column().label ? (column().label! | translate) : ''"
      />
    </td>
  `,
  styles: `
    :host {
      display: contents;
    }

    .table-row-checkbox {
      text-align: center;
      padding-left: var(--spacing-4);
      padding-top: var(--spacing-1);
      padding-bottom: var(--spacing-1);
    }

    @media (max-width: 768px) {
      .table-row-checkbox {
        width: 2.5rem;
        padding-left: 0;
      }
    }
  `,
})
export class TableRowCheckboxComponent {
  private readonly tableData = inject(OcpTableData);

  readonly column = input.required<TableColumnConfig>();
  readonly rowId = input.required<string>();
  readonly disabled = input(false);

  protected readonly isSelected = computed(() => this.tableData.isSelected(this.rowId()));

  protected readonly columnWidth = computed(() =>
    getResolvedColumnWidth(
      this.column(),
      this.tableData.columnSizing(),
      this.tableData.columnWidthPercentages()
    )
  );

  protected onSelectChange(): void {
    if (this.disabled()) {
      return;
    }
    this.tableData.toggleItemSelection(this.rowId());
  }
}
